const BatteryIcon = ({ backgroundFill, fillColor, strokeColor, strokeWidth, width }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 51 90.5" width={width}>
      <rect
        x="3"
        y="13"
        width="45"
        height="74.5"
        fill={backgroundFill}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5,3h26.1c1,0,1.8.9,1.8,2.1v5.1c0,1.1-.8,2.1-1.8,2.1H12.5c-1,0-1.8-.9-1.8-2.1v-5.1c0-1.1.8-2.1,1.8-2.1Z"
        fill={fillColor}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <rect x="9" y="68.7" width="33" height="12.4" rx="1.8" ry="1.8" fill={fillColor} />
      <rect x="9" y="52.3" width="33" height="12.4" rx="1.8" ry="1.8" fill={fillColor} />
      <rect x="9" y="35.9" width="33" height="12.4" rx="1.8" ry="1.8" fill={fillColor} />
      <rect x="9" y="19.5" width="33" height="12.4" rx="1.8" ry="1.8" fill={fillColor} />
    </svg>
  );
};

export default BatteryIcon;
